export class InventInfoModel {
    item_no: string
    code_fix: string
    code_active: string
    order_no: string | number
    item_tax1: string | boolean
    item_tax2: string | boolean
    item_tax3: string | boolean
    code_category: string
    code_sub_category: string
    code_approval: string
    brief_history_category: string
    item_presc_code: string
    code_specie: string
    item_waste: string | boolean
    unit_price: string
    item_base_charge: string
    item_strength: string
    unit_of_measure: string
    admin_route: string
    item_log: string
    item_warning: string | boolean
    discount_qty: string
    discount_amount: string
    smallest_unit: string
    code_modified_date: string
    item_class: string
    item_comm_1: string
    item_comm_2: string
    item_comm_3: string
    price_markup: string
    admin_location: string
    qty_on_hand: string | number
    reorder_point: string | number
    max_stock_level: string | number
    qty_month_1: string
    qty_month_2: string
    qty_month_3: string
    qty_month_4: string
    qty_month_5: string
    qty_month_6: string
    qty_month_7: string
    qty_month_8: string
    qty_month_9: string
    qty_month_10: string
    qty_month_11: string
    qty_month_12: string
    qty_this_month: string
    qty_ytd: string
    markup_fix: string | boolean
    auto_adjust: string | boolean
    days_supply: string
    unit_per_issue: string | number
    day1: number
    day2: number
    day3: number
    day4: number
    day5: number
    day6: number
    day7: number
    day8: number
    day9: number
    day10: number
    day11: number
    day12: number
    day13: number
    day14: number
    day15: number
    day16: number
    day17: number
    day18: number
    day19: number
    day20: number
    day21: number
    day22: number
    day23: number
    day24: number
    day25: number
    day26: number
    day27: number
    day28: number
    day29: number
    day30: number
    day31: number

    tag: any
    item_code: any
    code_no: any
    code_type: any
    code_clinic: any
    item_desc: any
    code_name: any
    manufacturer_code: string

    codes: string[]
    remarks: string

    nonprofit_markup_fix: boolean
    nonprofit_price_markup: string
    unit_rescueprice: string 

    constructor(
        item_no: string,
        code_fix: string,
        code_active: string,
        order_no: string | number,
        item_tax1: string | boolean,
        item_tax2: string | boolean,
        item_tax3: string | boolean,
        code_category: string,
        code_sub_category: string,
        code_approval: string,
        brief_history_category: string,
        item_presc_code: string,
        code_specie: string,
        item_waste: string | boolean,
        unit_price: string,
        item_base_charge: string,
        item_strength: string,
        unit_of_measure: string,
        admin_route: string,
        item_log: string,
        item_warning: string | boolean,
        discount_qty: string,
        discount_amount: string,
        smallest_unit: string,
        code_modified_date: string,
        item_class: string,
        item_comm_1: string,
        item_comm_2: string,
        item_comm_3: string,
        price_markup: string,
        admin_location: string,
        qty_on_hand: string | number,
        reorder_point: string | number,
        max_stock_level: string | number,
        qty_month_1: string,
        qty_month_2: string,
        qty_month_3: string,
        qty_month_4: string,
        qty_month_5: string,
        qty_month_6: string,
        qty_month_7: string,
        qty_month_8: string,
        qty_month_9: string,
        qty_month_10: string,
        qty_month_11: string,
        qty_month_12: string,
        qty_this_month: string,
        qty_ytd: string,
        markup_fix: string | boolean,
        auto_adjust: string | boolean,
        days_supply: string,
        unit_per_issue: string | number,
        day1: number,
        day2: number,
        day3: number,
        day4: number,
        day5: number,
        day6: number,
        day7: number,
        day8: number,
        day9: number,
        day10: number,
        day11: number,
        day12: number,
        day13: number,
        day14: number,
        day15: number,
        day16: number,
        day17: number,
        day18: number,
        day19: number,
        day20: number,
        day21: number,
        day22: number,
        day23: number,
        day24: number,
        day25: number,
        day26: number,
        day27: number,
        day28: number,
        day29: number,
        day30: number,
        day31: number,
        tag: any,
        item_code: any,
        code_no: any,
        code_type: any,
        code_clinic: any,
        item_desc: any,
        code_name: any,
        manufacturer_code: string,
        codes: string[],
        remarks: string,
        nonprofit_markup_fix: boolean,
        nonprofit_price_markup: string,
        unit_rescueprice: string 
    ) {
        this.item_no = item_no;
        this.code_fix = code_fix;
        this.code_active = code_active;
        this.order_no = order_no;
        this.item_tax1 = item_tax1;
        this.item_tax2 = item_tax2;
        this.item_tax3 = item_tax3;
        this.code_category = code_category;
        this.code_sub_category = code_sub_category;
        this.code_approval = code_approval;
        this.brief_history_category = brief_history_category;
        this.item_presc_code = item_presc_code;
        this.code_specie = code_specie;
        this.item_waste = item_waste;
        this.unit_price = unit_price;
        this.item_base_charge = item_base_charge;
        this.item_strength = item_strength;
        this.unit_of_measure = unit_of_measure;
        this.admin_route = admin_route;
        this.item_log = item_log;
        this.item_warning = item_warning;
        this.discount_qty = discount_qty;
        this.discount_amount = discount_amount;
        this.smallest_unit = smallest_unit;
        this.code_modified_date = code_modified_date;
        this.item_class = item_class;
        this.item_comm_1 = item_comm_1;
        this.item_comm_2 = item_comm_2;
        this.item_comm_3 = item_comm_3;
        this.price_markup = price_markup;
        this.admin_location = admin_location;
        this.qty_on_hand = qty_on_hand;
        this.reorder_point = reorder_point;
        this.max_stock_level = max_stock_level;
        this.qty_month_1 = qty_month_1;
        this.qty_month_2 = qty_month_2;
        this.qty_month_3 = qty_month_3;
        this.qty_month_4 = qty_month_4;
        this.qty_month_5 = qty_month_5;
        this.qty_month_6 = qty_month_6;
        this.qty_month_7 = qty_month_7;
        this.qty_month_8 = qty_month_8;
        this.qty_month_9 = qty_month_9;
        this.qty_month_10 = qty_month_10;
        this.qty_month_11 = qty_month_11;
        this.qty_month_12 = qty_month_12;
        this.qty_this_month = qty_this_month;
        this.qty_ytd = qty_ytd;
        this.markup_fix = markup_fix;
        this.auto_adjust = auto_adjust;
        this.days_supply = days_supply;
        this.unit_per_issue = unit_per_issue;
        this.day1 = day1;
        this.day2 = day2;
        this.day3 = day3;
        this.day4 = day4;
        this.day5 = day5;
        this.day6 = day6;
        this.day7 = day7;
        this.day8 = day8;
        this.day9 = day9;
        this.day10 = day10;
        this.day11 = day11;
        this.day12 = day12;
        this.day13 = day13;
        this.day14 = day14;
        this.day15 = day15;
        this.day16 = day16;
        this.day17 = day17;
        this.day18 = day18;
        this.day19 = day19;
        this.day20 = day20;
        this.day21 = day21;
        this.day22 = day22;
        this.day23 = day23;
        this.day24 = day24;
        this.day25 = day25;
        this.day26 = day26;
        this.day27 = day27;
        this.day28 = day28;
        this.day29 = day29;
        this.day30 = day30;
        this.day31 = day31;
        this.tag = tag;
        this.item_code = item_code;
        this.code_no = code_no;
        this.code_type = code_type;
        this.code_clinic = code_clinic;
        this.item_desc = item_desc;
        this.code_name = code_name;
        this.manufacturer_code = manufacturer_code;
        this.codes = codes;
        this.remarks = remarks;
        this.nonprofit_markup_fix = nonprofit_markup_fix
        this.nonprofit_price_markup = nonprofit_price_markup
        this.unit_rescueprice = unit_rescueprice 
    }
}